import React, { PureComponent } from "react";

export default class GQ extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.337"
      >
        <g transform="translate(0 -85.331)">
          <rect
            width="512"
            height="341.326"
            transform="translate(0 85.337)"
            fill="#f0f0f0"
          />
          <rect
            width="512"
            height="113.775"
            transform="translate(0 85.337)"
            fill="#6da544"
          />
          <rect
            width="512"
            height="113.775"
            transform="translate(0 312.888)"
            fill="#d80027"
          />
          <path d="M256,256.006,0,426.668V85.331Z" fill="#0052b4" />
          <path
            d="M279.807,219.71v44.444c0,27.216,35.555,35.556,35.555,35.556s35.555-8.339,35.555-35.556V219.71Z"
            fill="#dedde0"
          />
          <rect
            width="17.778"
            height="25.778"
            transform="translate(306.477 256.156)"
            fill="#786145"
          />
          <path
            d="M333.141,246.377a17.778,17.778,0,0,0-35.556,0,8.889,8.889,0,1,0,0,17.778H333.14a8.889,8.889,0,0,0,0-17.778Z"
            fill="#6da544"
          />
        </g>
      </svg>
    );
  }
}
